module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flexContainer full"
  }, [(_vm.displayBasket) ? _c('ModalBasket', {
    on: {
      "hideBasketModal": _vm.modalClose
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "flexContainer t-fd-c fd-c full",
    attrs: {
      "id": "catalog"
    }
  }, [_c('section', {
    staticClass: "catalogWrapper flexContainer t-jc-sb jc-sb mobileNot"
  }, [_c('aside', {
    staticClass: "searchBar tabletNot size1of4 flexContainer t-fd fd-c rel"
  }, [_c('div', {
    staticClass: "btnExp primary-text primary-border-color iBlock pointer clear mobileNot txtCenter",
    class: {
      active: this.$route.query.type || this.$route.query.category
    },
    on: {
      "click": function($event) {
        _vm.updateQuery({});
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("catalogue.clear")) + "\n                ")]), _vm._v(" "), _c('Picker', {
    attrs: {
      "getLinkParams": _vm.getLinkParams,
      "getRouteParams": _vm.getRouteParams,
      "categories": _vm.categories,
      "systemTypes": _vm.systemTypes,
      "sections": _vm.sections,
      "types": _vm.types,
      "standDesigns": _vm.standDesigns,
      "status": _vm.status
    },
    on: {
      "updateQuery": _vm.updateQuery
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fixed sortContainer full"
  }, [_c('div', {
    staticClass: "flexContainer m-jc-sa sortFilter tabletOnly uppercase",
    attrs: {
      "id": "filterMobile"
    }
  }, [_c('p', {
    staticClass: "pointer",
    on: {
      "click": _vm.showFilters
    }
  }, [_vm._v(_vm._s(_vm.$t("catalogue.filter")))])])]), _vm._v(" "), _c('section', {
    staticClass: "searchResultsWrapper rel size3of4 flexContainer fd-c t-fd-c m-fd-c t-ai-s"
  }, [_c('loader', {
    attrs: {
      "position": 'fixed',
      "spinLeft": '60%',
      "loading": _vm.loader
    }
  }), _vm._v(" "), _c('header', {
    staticClass: "queryWrapper flexContainer fd-c t-fd-c"
  }, [_c('div', {
    staticClass: "queryResults ff-medium primary-text"
  }, [_c('div', {
    staticClass: "queryResults ff-medium"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("catalogue.weFound")) + "\n                            "), _c('span', {
    staticClass: "ff-light",
    style: ('color:' + _vm.getBrandColor + ';')
  }, [(typeof _vm.routeParams.search !== 'undefined') ? _c('span', {
    staticClass: "ff-medium returned"
  }, [_vm._v(" " + _vm._s(_vm.$t("catalogue.for")) + "\n                                    "), _c('span', {
    staticClass: "ff-black",
    style: ('color:' + _vm.getBrandColor + ';')
  }, [_vm._v(_vm._s(_vm.routeParams.search) + " ")])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "ff-medium returned",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t("catalogue.return")))]), _vm._v(" "), _c('span', {
    staticClass: "ff-black",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.getMetaTotal))])]), _vm._v("\n                            " + _vm._s(_vm.$t("catalogue.results")) + "\n                        ")]), _vm._v(" "), (_vm.showForecastAddButton) ? _c('ClientColorButton', {
    staticStyle: {
      "margin-top": "10px"
    },
    on: {
      "click": _vm.addSelectionToForecasts
    }
  }, [_vm._v("add filtered selection to forecast  "), _c('ForecastIcon', {
    staticStyle: {
      "height": "15px"
    },
    attrs: {
      "color": '#fff'
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden"
  }, [_vm._v("filters")]), _vm._v(" "), _c('div', {
    staticClass: "flexContainer jc-sb"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('Pagination', {
    attrs: {
      "componentName": 'Catalog',
      "meta": _vm.getMeta,
      "page": _vm.currentPage
    }
  })], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "resultsWrapper"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.getVueResults), function(item, index) {
    return _c('ComponentListItem', {
      key: item.id,
      attrs: {
        "page": 'catalogue',
        "index": index,
        "item": item,
        "device": 'desktop'
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "flexContainer jc-sb"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('Pagination', {
    attrs: {
      "componentName": 'Catalog',
      "meta": _vm.getMeta,
      "page": _vm.currentPage
    }
  })], 1)])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "catalogWrapper mobileOnly tabletNot flexContainer m-fd-r rel"
  }, [_c('div', {
    staticClass: "fixed sortContainer full"
  }, [_c('div', {
    staticClass: "flexContainer m-jc-sa sortFilter uppercase"
  }, [_c('p', {
    staticClass: "pointer",
    on: {
      "click": _vm.showFilters
    }
  }, [_vm._v(_vm._s(_vm.$t("catalogue.filter")))])])]), _vm._v(" "), _c('section', {
    staticClass: "searchResultsWrapper flexContainer full t-fd-c fd-c t-ai-s"
  }, [_c('header', {
    staticClass: "queryWrapper flexContainer t-fd-c fd-c"
  }, [_c('div', {
    staticClass: "queryResults ff-medium"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("catalogue.weFound")) + "\n                        "), (typeof _vm.routeParams.search !== 'undefined') ? _c('span', [_vm._v(_vm._s(_vm.$t("catalogue.for")) + "\n                            "), _c('span', {
    staticClass: "ff-light",
    style: ('color:' + _vm.getBrandColor + ';')
  }, [_vm._v(" " + _vm._s(_vm.routeParams.search))])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "ff-light",
    style: ('color:' + _vm.getBrandColor + ';')
  }, [_c('span', {
    staticClass: " ff-medium returned"
  }, [_vm._v("returned")]), _vm._v(" "), _c('span', {
    staticClass: "ff-black"
  }, [_vm._v(_vm._s(_vm.getMetaTotal))])]), _vm._v("\n                        " + _vm._s(_vm.$t("catalogue.results")) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "hidden"
  }, [_vm._v("filters")])]), _vm._v(" "), _c('section', {
    staticClass: "resultsWrapper flexContainer fw-w "
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.getVueResults), function(item, index) {
    return _c('ComponentListItem', {
      key: item.id,
      attrs: {
        "page": 'catalogue',
        "index": index,
        "item": item,
        "device": 'mobile'
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "flexContainer jc-sb"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), (_vm.getMetaTotalPage > 1) ? _c('div', {
    staticClass: "pagination center"
  }, [_c('Pagination', {
    attrs: {
      "componentName": 'Catalog',
      "meta": _vm.getMeta,
      "page": _vm.currentPage
    }
  })], 1) : _vm._e()])])])]), _vm._v(" "), _c('section', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.filterMobile) ? _c('section', {
    staticClass: "mobileOnly",
    attrs: {
      "id": "filterMobile"
    }
  }, [_c('div', {
    staticClass: "flexContainer m-jc-sb t-jc-sb"
  }, [_c('button', {
    staticClass: "clear btn iBlock pointer"
  }, [_c('router-link', {
    class: {
      active: this.$route.query.type || this.$route.query.category || this.$route.query.subcategory
    },
    attrs: {
      "to": "/catalog"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("catalogue.clear")) + "\n                        ")])], 1), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.closeFilters
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/croix.png"),
      "width": "28",
      "height": "28",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('section', {
    staticClass: "searchBar flexContainer fd-c"
  }, [_c('section', {
    staticClass: "composantsPickerWrapper"
  }, [(_vm.getLength('sections') > 1) ? _c('ul', _vm._l((_vm.sections), function(item, index) {
    return _c('li', {
      key: item.id
    }, [_c('router-link', {
      staticClass: "componentType",
      class: {
        active: _vm.sector === index
      },
      attrs: {
        "to": {
          name: 'Catalog',
          query: _vm.getLinkParams({
            sections: item.id
          })
        },
        "exact": ""
      }
    }, [_c('span', {
      on: {
        "click": _vm.closeFilters
      }
    }, [_vm._v(_vm._s(item.name))])])], 1)
  })) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "sectionPickerWrapper"
  }, [_c('ul', _vm._l((_vm.types), function(item, index) {
    return _c('li', {
      key: item.id,
      attrs: {
        "id": "typeOfSector"
      }
    }, [_c('router-link', {
      staticClass: "sectionType",
      class: {
        active: _vm.type === index
      },
      attrs: {
        "to": {
          name: 'Catalog',
          query: _vm.getLinkParams({
            type: item.id
          })
        },
        "exact": ""
      }
    }, [_c('span', {
      on: {
        "click": _vm.closeFilters
      }
    }, [_vm._v(_vm._s(item.name))])])], 1)
  }))]), _vm._v(" "), _c('section', {
    staticClass: "categoriesPickerWrapper"
  }, [_c('CategoryPicker', {
    attrs: {
      "categories": _vm.categories,
      "getLinkParams": _vm.getLinkParams,
      "hauteur": 1,
      "isActive": 1
    },
    on: {
      "updateQuery": _vm.updateQuery
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "validFilters flexContainer m-fd-c m-jc-c"
  }, [_c('button', {
    staticClass: "btn ff-light center",
    on: {
      "click": _vm.closeFilters
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-dark ff-light center"
  }, [_vm._v(_vm._s(_vm.$t("common.finish")))])])])]) : _vm._e()])], 1), _vm._v(" "), (_vm.isForecastModalActive) ? _c('ForecastModal', {
    attrs: {
      "items": _vm.allResults.data
    },
    on: {
      "close": function($event) {
        _vm.isForecastModalActive = false;
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60f9a1c9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/catalog/Catalog.vue
// module id = 3218
// module chunks = 0